<template>
  <div class="schedule-editor">
    <div class="md-layout" v-if="!everythingLoaded">
      <div class="md-layout-item md-large-size-100">
        <md-card>
          <md-card-content>
            <h4>Rooster wordt geladen...</h4>
          </md-card-content>
        </md-card>
      </div>
    </div>
    <schedule-editor-toolbar
      v-if="everythingLoaded"
      :disabled="disabled"
      :touched="touched"
      v-model="data"
      :data="data"
      @generateSchedule="this.generateSchedule"
      @generatePdf="this.generatePdf"
    ></schedule-editor-toolbar>
    <div class="md-layout" v-if="everythingLoaded">
      <div
        v-for="(day, index) in data.schedule.days"
        class="md-layout-item md-large-size-25 md-medium-size-33 md-small-size-50 md-xsmall-size-100"
        :key="index"
      >
        <schedule-editor-day
          :disabled="disabled"
          v-model="data.schedule.days[index]"
          :data="data.schedule.days[index]"
          :help-tool-tips-enabled="data.helpToolTipsEnabled"
          :driver-details="data.drivers"
          :language-details="data.language"
          :data-day-index="index"
          :data-max-shifts-per-day="dataMaxShiftsPerDay"
        ></schedule-editor-day>
      </div>
    </div>
    <schedule-editor-toolbar
      v-if="everythingLoaded"
      :disabled="disabled"
      :touched="touched"
      v-model="data"
      :data="data"
      @generateSchedule="this.generateSchedule"
      @generatePdf="this.generatePdf"
    ></schedule-editor-toolbar>
    <schedule-editor-legend v-if="everythingLoaded"></schedule-editor-legend>
  </div>
</template>

<script>
import scheduleEditorDay from "./ScheduleEditorDay.vue";
import scheduleEditorLegend from "./ScheduleEditorLegend.vue";
import scheduleEditorToolbar from "./ScheduleEditorToolbar.vue";

export default {
  data() {
    return {
      data: {
        schedule: {
          days: []
        },
        drivers: {},
        language: {
          schedule: {
            label: {
              toolTip:
                "De titel van het rooster geeft aan voor welke week & jaar het rooster is."
            },
            dayLabel: {
              toolTip:
                "De dag van de week & de datum voor de diensten in deze kolom."
            },
            group: {
              toolTip: "De groepnaam van de onderstaande diensten."
            },
            route: {
              toolTip: "De naam van de route."
            },
            shift: {
              toolTip: "De start tijd van de dienst.",
              dropdown: {
                toolTip:
                  "De lijst met chauffeurs. [1] = 1 chauffeur met de status beschikbaar in de lijst. (2/3) = chauffeur staat al voor 2 van de maximale 3 diensten ingeroosterd."
              },
              checkbox: {
                toolTip:
                  "Het vast zetten van een chauffeur zorgt ervoor dat deze niet aangepast wordt wanneer het rooster door het systeem genenereerd wordt."
              }
            },
            button: {
              save: {
                label: "Opslaan",
                toolTip: "Bewaar het rooster in de database."
              },
              generate: {
                label: "Genereer Rooster",
                toolTip:
                  "Laat het programma de diensten invullen welke niet opslot zitten."
              },
              check: {
                label: "Controleer Rooster",
                toolTip: "Controleer het rooster op fouten."
              },
              generatePdf: {
                label: "Download PDF",
                toolTip: "Download PDF bestand van dit rooster."
              },
              lock: {
                label: "Op slot",
                label2: "Van slot",
                toolTip: "Zet alle diensten op slot.",
                toolTip2: "Haal alle diensten van slot."
              },
              lockReserve: {
                label: "Reserves op slot",
                label2: "Reserves van slot",
                toolTip: "Zet alle reserve diensten op slot.",
                toolTip2: "Haal alle reserve diensten van slot."
              },
              reset: {
                label: "Reset Rooster",
                toolTip: "Maak het rooster helemaal leeg."
              },
              publish: {
                label: "Gepubliceerd",
                label2: "Niet gepubliceerd",
                toolTip: "Trek deze publicatie in.",
                toolTip2: "Publiceer het rooster."
              },
              help: {
                label: "",
                label2: "",
                toolTip: "Schakel hulp teksten in.",
                toolTip2: "Schakel hulp teksten uit."
              }
            }
          }
        },
        helpToolTipsEnabled: false,
        loaded: {
          items: false,
          drivers: false
        },
        itemChangeInitTimeout: null
      },
      touched: {
        scheduleItems: false
      },
      skippedFirstDataWatches: 0,
      disabled: false,
      driversShiftsScheduled: []
    };
  },
  mounted() {
    this.fetchDrivers();
    this.fetchSchedule();
  },
  components: {
    scheduleEditorDay: scheduleEditorDay,
    scheduleEditorLegend: scheduleEditorLegend,
    scheduleEditorToolbar: scheduleEditorToolbar
  },
  props: ["scheduleId", "dataMaxShiftsPerDay"],

  watch: {
    // drivers: function (newQuestion, oldQuestion) {
    //     console.log('drivers changed');
    // },
    data: {
      handler(newVal, oldVal) {
        // console.log("Schedule changed");
        if (this.everythingLoaded && this.skippedFirstDataWatches > 2) {
          this.touched.scheduleItems = true;
          this.$emit("changed", true);
        } else if (this.everythingLoaded && this.skippedFirstDataWatches <= 2) {
          this.skippedFirstDataWatches++;
        }

        if (
          this.everythingLoaded &&
          (this.driversShiftsScheduled.length === 0 ||
            this.hasShiftDriverChanged(newVal, this.driversShiftsScheduled))
        ) {
          // console.log("calc");
          this.driversShiftsScheduled = JSON.parse(JSON.stringify(newVal));
          // console.log(this.hasShiftDriverChanged(newVal, oldVal));
          this.updateDriversShiftsScheduled();
        }
      },
      deep: true
    },
    scheduleId: {
      handler(newVal, oldVal) {
        this.data.schedule = {};
        this.data.drivers = {};
        this.fetchSchedule();
        this.fetchDrivers();
      }
    }
  },
  computed: {
    everythingLoaded: function() {
      for (let i in this.data.loaded) {
        if (!this.data.loaded[i]) {
          return false;
        }
      }

      return true;
    }
  },
  methods: {
    hasShiftDriverChanged(newVal, oldVal) {
      for (let dayIndex in oldVal.schedule.days) {
        for (let groupIndex in oldVal.schedule.days[dayIndex].groups) {
          for (let routeIndex in oldVal.schedule.days[dayIndex].groups[
            groupIndex
          ].routes) {
            for (let shiftIndex in oldVal.schedule.days[dayIndex].groups[
              groupIndex
            ].routes[routeIndex].shifts) {
              let oldDriverId =
                oldVal.schedule.days[dayIndex].groups[groupIndex].routes[
                  routeIndex
                ].shifts[shiftIndex].values.driver;
              let newDriverId =
                newVal.schedule.days[dayIndex].groups[groupIndex].routes[
                  routeIndex
                ].shifts[shiftIndex].values.driver;
              if (oldDriverId !== newDriverId) {
                return true;
              }
            }
          }
        }
      }

      return false;
    },
    fetchSchedule() {
      this.data.loaded.items = false;
      this.$http
        .get(this.$apiBaseUrl + "schedules/" + this.scheduleId + "/items")
        .then(response => {
          this.data.schedule = response.data.schedule;
          setTimeout(() => {
            this.data.loaded.items = true;

            if (this.everythingLoaded) {
              setTimeout(() => {
                this.resetFormTouched();
              }, 1500);
            }
          }, 500);
        });
    },
    calculateSchedule() {
      this.disabled = true;
      this.notifyVue(
        "Het rooster wordt nu gegenereerd. Dit kan enkele ogenblikken in beslag nemen.",
        "hourglass_top",
        "success",
        5000
      );
      this.$http
        .post(
          this.$apiBaseUrl + "schedules/" + this.scheduleId + "/calculate",
          Object.assign({
            schedule: this.data.schedule,
            scheduleDrivers: this.data.drivers
          })
        )
        .then(
          response => {
            this.data.schedule = response.data.schedule;
            this.disabled = false;

            if (response.data.shiftsWithoutAvailableDriver === 0) {
              this.notifyVue(
                "Het rooster is succesvol gegenereerd. Alle diensten hebben een beschikbare chauffeur.",
                "check",
                "success",
                0
              );
            } else if (
              response.data.shiftsWithoutAvailableDriver ===
              response.data.shiftsWithoutDriver
            ) {
              this.notifyVue(
                "Het rooster is succesvol gegenereerd. Er is/zijn " +
                  response.data.shiftsWithoutDriver +
                  " dienst(en) zonder chauffeur.",
                "priority_high",
                "warning",
                0
              );
            } else {
              this.notifyVue(
                "Het rooster is succesvol gegenereerd. Er is/zijn " +
                  response.data.shiftsWithoutAvailableDriver +
                  " dienst(en) waar de chauffeur niet beschikbaar is, waarvan " +
                  response.data.shiftsWithoutDriver +
                  " dienst(en) zonder chauffeur.",
                "priority_high",
                "warning",
                0
              );
            }
          },
          response => {
            if (response.status === 403) {
              this.notifyVue(
                "Er is een fout opgetreden tijdens het genereren van het rooster.",
                "add_alert",
                "danger",
                0
              );
            }
          }
        );
    },
    downloadPdf() {
      this.notifyVue(
        "PDF rooster " +
          this.data.schedule.year +
          " week " +
          this.data.schedule.week +
          " download gestart",
        "check",
        "success",
        5000
      );
      this.disabled = true;
      this.$http
        .get(this.$apiBaseUrl + "schedules/" + this.scheduleId + "/pdf", {
          responseType: "blob"
        })
        .then(response => {
          const filename = response.headers.map["content-disposition"][0]
            .split(";")[1]
            .split("filename")[1]
            .split("=")[1]
            .trim()
            .replaceAll('"', "");
          const fileURL = window.URL.createObjectURL(new Blob([response.data]));
          const fURL = document.createElement("a");

          fURL.href = fileURL;
          fURL.setAttribute("download", filename);
          document.body.appendChild(fURL);
          fURL.click();
          document.body.removeChild(fURL);
          this.disabled = false;
        });
    },
    fetchDrivers() {
      this.data.loaded.drivers = false;
      this.$http
        .get(this.$apiBaseUrl + "schedules/" + this.scheduleId + "/drivers")
        .then(
          response => {
            var drivers = {};
            for (var i in response.data.scheduleDrivers) {
              drivers[response.data.scheduleDrivers[i].id] =
                response.data.scheduleDrivers[i];
            }
            this.data.drivers = drivers;
            setTimeout(() => {
              this.data.loaded.drivers = true;

              if (this.everythingLoaded) {
                setTimeout(() => {
                  this.resetFormTouched();
                }, 1500);
              }
            }, 500);
          },
          response => {
            if (response.status === 403) {
              this.notifyVue(
                "U heeft geen rechten voor het beheren van roosters",
                "add_alert",
                "danger",
                0
              );
            }
          }
        );
    },
    saveSchedule() {
      this.disabled = true;
      this.$http
        .post(
          this.$apiBaseUrl + "schedules/" + this.scheduleId + "/items",
          Object.assign({
            schedule: this.data.schedule
          })
        )
        .then(
          response => {
            this.disabled = false;
            this.resetFormTouched();
            this.notifyVue(
              "Rooster items succesvol opgeslagen",
              "check",
              "success",
              5000
            );
          },
          response => {
            this.disabled = false;
            if (response.status === 422) {
              let msg = "";

              this.submitErrors = response.data.errors;

              for (var i in response.data.errors) {
                for (var j in response.data.errors[i]) {
                  msg += "<br/>\n&bull;&nbsp;" + response.data.errors[i];
                }
              }

              this.notifyVue(msg, "add_alert", "danger", 0);
            } else {
              this.notifyVue(
                "Onbekende fout tijdens opslaan rooster items",
                "report_problem",
                "danger",
                0
              );
            }
          }
        );
    },
    updateDriversShiftsScheduled() {
      var found = [];

      for (var dayIndex in this.data.schedule.days) {
        for (var groupIndex in this.data.schedule.days[dayIndex].groups) {
          for (var routeIndex in this.data.schedule.days[dayIndex].groups[
            groupIndex
          ].routes) {
            for (var shiftIndex in this.data.schedule.days[dayIndex].groups[
              groupIndex
            ].routes[routeIndex].shifts) {
              var driverId = this.data.schedule.days[dayIndex].groups[
                groupIndex
              ].routes[routeIndex].shifts[shiftIndex].values.driver;
              // console.log("(update) Found " + driverId);

              if (found[driverId] == undefined) {
                found[driverId] = [];
              }
              found[driverId].push(
                this.data.schedule.days[dayIndex].groups[groupIndex].routes[
                  routeIndex
                ].shifts[shiftIndex].date
              );
            }
          }
        }
      }

      for (var driverIndex in this.data.drivers) {
        if (found[this.data.drivers[driverIndex].id] == undefined) {
          this.data.drivers[driverIndex].shiftsScheduled = [];
        } else {
          this.data.drivers[driverIndex].shiftsScheduled =
            found[this.data.drivers[driverIndex].id];
        }
      }
      // console.log(found);
    },
    notifyVue(message, icon, type, timeout) {
      this.$notify({
        message: message,
        icon: icon,
        horizontalAlign: "center",
        verticalAlign: "top",
        type: type,
        timeout: timeout
      });
    },
    generateSchedule: function() {
      this.calculateSchedule();
    },
    generatePdf: function() {
      this.downloadPdf();
    },
    resetFormTouched() {
      this.touched.scheduleItems = false;
      this.$emit("resetScheduleTouched", true);
    }
  }
};
</script>
<style></style>
